import { render, staticRenderFns } from "./cScrollWrap.vue?vue&type=template&id=582f35ca&scoped=true&lang=pug"
import script from "./cScrollWrap.vue?vue&type=script&lang=js"
export * from "./cScrollWrap.vue?vue&type=script&lang=js"
import style0 from "./cScrollWrap.vue?vue&type=style&index=0&id=582f35ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582f35ca",
  null
  
)

export default component.exports